<template>
  <div class="advice_success" v-show="show">
      <img src="../../../assets/img/advice/advice_success_bg.png" alt="">
      <h2>你已经提交的问题，技术老师正在紧急处理</h2>
      <p><i>{{msg}}</i>后，可再次反馈新的问题</p>
  </div>
</template>
<script>
import common from "common";
import {mapState} from "vuex";
export default {
  data() {
    return {
      show:false,
      msg:'',
      interval:null
    };
  },
  computed:{
    ...mapState(['userID'])
  },
  created(){
    this.init();
  },
  methods: {
    init(){
      let data = common.get('advice_success_info') || {};
      if(data.uid == this.userID){
        let nowTime = Date.now();
        let time = data.time;
        let cTime = time-nowTime;
        cTime =  Math.floor(cTime/1000);
        if(cTime>0){
          this.show = true;
          this.time(cTime);
        }
      }
    },
    time(time){
      this.msg = this.formatTime(time);
      clearInterval(this.interval);
      this.interval = setInterval(()=>{
        time--;
        if(time<=0){
          this.show=false;
          return;
        }
        this.msg= this.formatTime(time);
      }, 1000);
    },
    formatTime(time) {
      let min = Math.floor(time / 60);
      let sec  = (time % 60);
      return min>0?`${min}分${sec}秒` : `${sec}秒`;
    }
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
};
</script>
<style lang="less" scoped>
  .advice_success{
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 20px;
    left:0;
    top:0;
    background: #F1F3F4;
    z-index: 999;
    img{
      width: 450px;
      margin-top: 150px;
    }
    h2{
      color: #333333;
      font-size: 26px;
      padding: 60px 0 25px 0;
    }
    p{
      font-size: 24px;
      color: #666666;
      i{
        color: #D14A4A;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/bussiness/advice/advice_success.vue